import { Key } from "react";
import { ENVMAPPING } from "./helper";
import EndpointImage from "assets/Endpoint";
import BatchImage from "assets/Batch";
import TrainingImage from "assets/Training";
import GroupIcon from "assets/GroupIcon";
import UserIcon from "assets/UserIcon";

type MenuListType = {
  [x: string]: Key | null | undefined;
  label: string;
  route: string;
  icon?: any;
};

export const MENU_LIST: MenuListType[] = [
  {
    label: "Home",
    route: "/",
    icon: "home",
  },

  {
    label: "TDSP",
    route: "/tdsp",
    icon: "arrow-right",
  },
];

type platformtype = {
  label: string;
  marginTop: string;
  icon: string;
};

type topmenulisttype = {
  headLabel: string;
  subList: Array<{
    label: string;
    link: string;
  }>;
};

interface ContentItem {
  title: string;
  contentItems: string[];
}

export interface CatalogItem {
  title: string;
  description: string;
  content: ContentItem[];
  docsRoute?: string;
  selectEndpoint: string;
  CardImage?: any;
  selectRoute?: string;
  cardIconPath?: string;
  serviceName?: string;
  info?: string;
  teamName?: string;
}

interface CatalogSection {
  title: string;
  items: CatalogItem[];
}

export const TOPMENULIST: topmenulisttype[] = [
  {
    headLabel: "DOCUMENTATION",
    subList: [
      {
        label: "About",
        link: "./",
      },
      {
        label: "TDSP",
        link: "/documentation",
      },
      {
        label: "Confluence",
        link: "/documentation/confluence",
      },
      // {
      //   label: "What is POD?",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/363699259/What+is+POD"
      // },
      // {
      //   label: "User Roles",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370335056/User+Roles"
      // },
      // {
      //   label: "AWS IAM Roles",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/373722811/AWS+IAM+Roles+-+TDSP+Managed"
      // },
      // {
      //   label: "Changeback",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370775084/Tags+-+Chargeback"
      // },
      // {
      //   label: "New POD Onboarding",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/359861389/New+Pod(Team)+Onboarding+Requests"
      // },
      // {
      //   label: "New User Onboarding",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/359860118/New+User+Onboarding+Request"
      // },
      // {
      //   label: "Sandbox Environment Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/362057955/Sandbox+Environment+Request"
      // },
      // {
      //   label: "Data Access Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/360356761/Data+Access+Request+DAR"
      // },
      // {
      //   label: "DevOps Platform Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370841626/DevOps+Platform+Request+Github+and+CI+CD"
      // },
      // {
      //   label: "Data Copy Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370841607/Data+Copy+Request"
      // },{
      //   label: "Secret Creation Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370776360/Secret+Creation+Request"
      // },{
      //   label: "Raising Incident",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370747414/Raising+Incident"
      // },
      // {
      //   label: "General Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370747442/General+Request"
      // },
      // {
      //   label: "AWS Environment",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370303306/How+to+access+AWS+Environment"
      // },
      // {
      //   label: "Databricks Environment",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370270171/How+to+access+Databricks"
      // },
      // {
      //   label: "Security",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370270524/Security+on+TDSP+Platform"
      // },
    ],
  },
  {
    headLabel: "Self Service",
    subList: [
      // {
      //   label: "New POD Onboarding",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/359861389/New+Pod(Team)+Onboarding+Requests"
      // },
      // {
      //   label: "New User Onboarding",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/359860118/New+User+Onboarding+Request"
      // },
      // {
      //   label: "Sandbox Environment Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/362057955/Sandbox+Environment+Request"
      // },
      // {
      //   label: "Data Access Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/360356761/Data+Access+Request+DAR"
      // },
      // {
      //   label: "DevOps Platform Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370841626/DevOps+Platform+Request+Github+and+CI+CD"
      // },
      // {
      //   label: "Data Copy Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370841607/Data+Copy+Request"
      // },{
      //   label: "Secret Creation Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370776360/Secret+Creation+Request"
      // },{
      //   label: "Raising Incident",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370747414/Raising+Incident"
      // },
      // {
      //   label: "General Request",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370747442/General+Request"
      // },
      {
        label: "MLOps Pipeline Initilization",
        link: "/mlops",
      },
    ],
  },
  {
    headLabel: "Monitoring Metrics",
    subList: [
      {
        label: "AWS Environment",
        link: "", //"https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370303306/How+to+access+AWS+Environment"
      },
      {
        label: "Databricks Environment",
        link: "", //"https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370270171/How+to+access+Databricks"
      },
      // {
      //   label: "Security",
      //   link: "https://toyota.atlassian.net/wiki/spaces/TDSP/pages/370270524/Security+on+TDSP+Platform"
      // },
    ],
  },
  {
    headLabel: "Supported Services",
    subList: [
      {
        label: "Data Engineering",
        link: "",
      },
    ],
  },
];

export const PLATFORMS: Array<platformtype> = [
  {
    label: "Data Engineering",
    marginTop: "0px",
    icon: "dataeng",
  },
  {
    label: "Model Development",
    marginTop: "3%",
    icon: "modeldev",
  },
  {
    label: "Model Expirements",
    marginTop: "6%",
    icon: "modeleng",
  },
  {
    label: "Model Registry",
    marginTop: "9%",
    icon: "modelreg",
  },
  {
    label: "Model Deployment",
    marginTop: "6%",
    icon: "modeldep",
  },
  {
    label: "Monitoring",
    marginTop: "3%",
    icon: "monitor",
  },
  {
    label: "Orchestration",
    marginTop: "0px",
    icon: "orchestrate",
  },
];

export const ONBOARDING_LIST = {
  id: "step0",
  title: "Toyota Data Sciene Platform (TDSP)",
  children: [
    {
      id: "tdsp-0",
      title: "Oboarding",
      children: [
        {
          id: "onboard-0",
          title: "Application Registration",
          children: [],
        },
        {
          id: "onboard-1",
          title: "New User",
          children: [],
        },
        {
          id: "onboard-2",
          title: "New Pod(Team)",
          children: [],
        },
        {
          id: "onboard-3",
          title: "Dev-Ops onboarding",
          children: [],
        },
      ],
    },
    {
      id: "tdsp-1",
      title: "Data Procurement/Access",
      children: [
        {
          id: "dpa-0",
          title: "Raise DAR (Data Access Request)",
          children: [
            {
              id: "dar-0",
              title: "AWS S3 Access",
              children: [],
            },
            {
              id: "dar-0",
              title: "AWS Redshift Access",
              children: [],
            },
          ],
        },
      ],
    },
    {
      id: "tdsp2",
      title: "Data Analysis",
      children: [],
    },
    {
      id: "tdsp3",
      title: "Data Science Workload",
      children: [],
    },
  ],
};

export const FLOW_CHART_NODES = `flowchart LR
    A[Toyota Data Sciene Platform - TDSP] --> B(Oboarding)
    B --> B1(Application Registration)
    B --> B2(New User)
    click B2 "https://www.github.com" "This is a tooltip for a link"
    B2 --> B2a(Techinal Req)
    B --> B3(New Pod/Team fa fa-link)
    style B2 stroke:#00f,stroke-width:4px,fill:transparent;
    style B3 stroke:#00f,stroke-width:4px,fill:transparent;
    style B4 stroke:#00f,stroke-width:4px,fill:transparent;
    click B3 "https://www.github.com" "This is a tooltip for a link"
    B3 --> B3a(Technical Requirement Gathering meeting schedule)
    B --> B4(Dev-Ops onboarding)
    click B4 "https://www.github.com" "This is a tooltip for a link"
    A --> C(Data Procurement/Access)
    C --> C1(Raise Data Access Request - DAR)
    C1 --> C1a(S3 Bucket Access)
    C1 --> C1b(Redshift Access)
    C1a --> link
    C1b --> link
    A --> D(Data Analysis)
    D --> D1(Services Available)
    D1 --> D1a(Databricks-DBX Integrative Notebook)
    D1a --> itemD1a1(How to Access)
    D1a --> itemD2a2(Best Practices for Analysis)
    D1 --> D1b(Athena)
    D1b --> itemD1b1(How to Access)
    D1b --> itemD2b2(Best Practices for Analysis)
    D1 --> D1c(Sagemaker Studio)
    D1c --> itemD1c1(How to Access)
    D1c --> itemD1c2(Best Practices for Analysis)
    A --> E(Data Science Workload)
    E --> E1(Machine Learning)
    E1 --> E1a(Model Taining/Building)
    E1a --> E1a1(Model Registering) --> itemE1a1(Model Inferencing)
    E --> E2(Data Engineering)
    A --> F(Visualize)
`;

export const SSO_CLIENT_ID = ENVMAPPING(window.location.origin).azure_app_id;
export const SSO_TENANT_URL = `https://login.microsoftonline.com/${
  ENVMAPPING(window.location.origin).azure_client_id
}`;
export const REDIRECT_URL = window.location.origin;
export const API = ENVMAPPING(window.location.origin).api;
export const ENCLAVE_URL = ENVMAPPING(window.location.origin).enclaveSwitchUrl || "";
export const MLOPS_TEMPLATES_TITLE = "MLOps Reusable Templates";
export const PLATFORM_DOCS = "Platform Docs";
export const submitText = "Submit";
export const nextText = "Next";
export const goBackText = "Go Back";
export const backText = "Back";
export const ONBOARDING = {
  pageTitle: "Onboarding",
  description:
    "Once you submit your request, we expect it to be processed in approximately 1 day.",
  podOnboarding: "Pod Onboarding",
  userOnboarding: "User Onboarding",
  userOnboardingDesc:
    "This selection will provide Add/Remove a user from existing team.",
  podOnboardingDesc:
    "This selection will provide Pod onboarding self service process.",
  wandbOnboarding: "Wandb onboarding",
  wandbOnboardingDesc:
    "This selection will provide Wandb onboarding self service process.",
};

export const USER_ONBOARDING = {
  userOnboarding: "User Onboarding",
  userOffBoarding: "User Offboarding",
  userOnboardingDesc:
    "User Onboarding enables new members to seamlessly join an existing POD in TDSP with the right access, tools, and resources.",
  userOffboardingDesc:
    "User Offboarding provides member removal from any TDSP team (Pod).",
  description:
    "Please fill in the form to Add/Remove user to an existing team. Once you submit your request, we expect it to be processed in approximately 1 day.",
  addUser: "Add User",
  removeUser: "Remove User",
  pod: "Pod Name",
  name: "Name",
  email: "Email",
  userRole: "Select roles",
  businessJustification: "Business justification",
  descriptionLabel: "Description",
  refreshButtonInfo: "Click on this button to refresh the request details",
  userServicesMessage: "User will get access of these services: ",
  ALL_ROLES: "All Roles",
  formTitle: "Initiate {USER_ACTION} Request",
};

export const POD_ONBOARDING = {
  pageTitle: "POD Onboarding",
  description:
    "Please fill in the form to initiate the Pod Onboarding Request. Once you submit your request, we expect it to be processed in approximately 6 days.",
  podNameLabel: "Pod Name",
  ciNameLabel: "CI Name (Configuration Item Name)",
  userEmailLabel: "User Email",
  userRoleLabel: "User Role",
  SERVICES_FOR_POD: "Services for POD:",
  ADD_USERS: "Add Users",
  SERVICES: "Services:",
  UPLOAD_ARCHITECTURE: "Upload Architecture diagram (if available)",
  UPLOAD_ARCHITECTURE_SUPPORTED_FORMAT: "Supported format: PDF",
  podAmbassadorEmail: "Pod Ambassador Email",
  businessVertical: "Business Vertical",
  projectDescription: "Project Description",
  ADD_USER_LATER: "I will add users later.",
  TYPE_OF_PAYLOAD_QUESTION: "What type of ML workload ?",
};

export const TDSPPageTitle = "TDSP";
export const TEMPLATE_CREATION_CONSTANTS = {
  WANDB_PROJECT_NAME_DESC:
    "Name of your project. This is used for creating repo, Weights and Biases registry reference and Pipeline name.",
  MODEL_NAME_DESC:
    "Name of the model your project uses. This should be unique within the scope of the team or project",
  WANDB_MODEL_VERSION_DESC:
    "Version of the model tracked in Weights & Biases. Default to v1",
};
export const VALIDATION_ERRORS = {
  email: "Invalid email address. Please use a Toyota address.",
};
export const requested_at = "Requested at";
export const questionList = [
  {
    title: "General Project Overview",
    questions: [
      {
        type: "input",
        label: "What is the goal of your project?",
        required: true,
        field: "projectGoals",
        info: "Hint: Specify the problem you're solving and desired outcomes.",
      },
      {
        type: "input",
        label: "What type of ML problem is this?",
        required: true,
        field: "typeOfMLProblem",
        info: "Hint: Classification, regression, clustering, NLP, etc.",
      },
      {
        type: "input",
        label: "Who are your end users?",
        required: true,
        field: "endUser",
        info: "Hint: Mention the target audience or stakeholders.",
      },
    ],
  },
  {
    title: "Data-Related Questions",
    questions: [
      {
        type: "input",
        label: "What data will you use, and where is it stored?",
        required: true,
        field: "typeOfDataAndStorage",
        info: "Hint: Specify data type, format, and storage location (example: TBDP, TC, etc)",
      },
      {
        type: "input",
        label: "Are there privacy or compliance requirements?",
        required: true,
        field: "privacyAndCompliance",
        info: "Hint: GDPR, HIPAA, or internal policies.",
      },
    ],
  },
  {
    title: "Model Development and Training",
    questions: [
      {
        type: "input",
        label: "What frameworks or libraries will you use?",
        required: true,
        field: "frameworksOrLibraries",
        info: "Hint: TensorFlow, PyTorch, Scikit-learn, etc.",
      },
      {
        type: "input",
        label:
          "Do you have any special compute requirements for training/inferencing?",
        required: true,
        field: "computeRequirment",
        info: "Hint: Bigger instances or GPU needs",
      },
    ],
  },
  {
    title: "Deployment and Monitoring",
    questions: [
      {
        type: "input",
        label: "What is your deployment strategy?",
        required: true,
        field: "deploymentStrategy",
        info: "Hint: Real-time API, batch jobs, etc.",
      },
      {
        type: "input",
        label: "How will you monitor performance?",
        required: true,
        field: "performanceMonitor",
        info: "Hint: Define metrics and monitoring tools.",
      },
    ],
  },
  {
    title: "Resource and Cost Management",
    questions: [
      {
        type: "input",
        label: "Do you expect high usage costs?",
        required: true,
        field: "usageCost",
        info: "Hint: Yes, if running frequent jobs or large models.",
      },
    ],
  },
];

export const POD_ONBOARDING_STEP_TITLES = [
  "Basic Details",
  "Project Requirements",
  "Add Users",
];
export const onboardingType = {
  user_onboarding_add: "Add User",
  user_onboarding_remove: "Remove User",
  pod_onboarding: "Pod Onboarding",
  cloud_request: "Cloud Service Provisioning",
};

export const WANDB_ONBOARDING = {
  pageTitle: "Wandb Onboarding",
  description: "Please fill this form to raise request for wandb onboarding.",
  addUser: "Add User",
  removeUser: "Remove User",
  pod: "POD",
  name: "Name",
  email: "Email",
  userRole: "User role",
  businessJustification: "Business justification",
  descriptionLabel: "Description",
  userServicesMessage: "User will get access of these services: ",
};
export const REQUEST_DETAILS_TEXT = "Request details";
export const ONBOARDING_STATUS = "Onboarding Status";

export const requestDetailsItemMapping = {
  initiate_request: "Request Initiated",
  initiate_pod_request: "Pod Request Initiated",
  "1ts": "TDSP Platform Approval",
  azure_onboarding: "Azure Onboarding",
  sagemaker_provisioning: "SageMaker Provisioning",
  sagemaker_onboarding: "SageMaker Provisioning",
  cloudops_request: "Britive Onboarding",
  azure_iam_request: "Azure IAM Request",
  role_policy_creation: "Roles/Policy Provisioning",
  role_policy_creation_prod: "Roles/Policy Provisioning (PROD)",
  databricks_onboarding: "Databricks Provisioning",
  onboarding_users: "Users Onboarding",
  manager_approval: "Manager Approval",
  azure_offboarding: "Azure Offboarding",
  cloud_request_execution: "Cloud Request Execution",
  gha_team_mapping: "GHA Team Mapping",
  wandb_onboarding: "Weights and Biases Provisioning",
};

export const requestDetailsSLAMapping = {
  "1ts": "1-2 Days",
  azure_onboarding: "2-3 Days",
  sagemaker_provisioning: "1-2 Hr",
  sagemaker_onboarding: "1-2 Hr",
  cloudops_request: "3-4 Days",
  azure_iam_request: "3-4 Days",
  role_policy_creation: "1-2 Hr",
  databricks_onboarding: "1-2 Hr",
  onboarding_users: "1-2 Hr",
  manager_approval: "1-2 Days",
};

export const REQUEST_DETAILS_ETA_MAPPING = {
  manager_approval: {
    pod_onboarding: {
      day: 2,
    },
    user_onboarding: {
      day: 0,
    },
  },
  "1ts": {
    pod_onboarding: {
      day: 4,
    },
    user_onboarding: {
      day: 2,
    },
    cloud_request: {
      day: 2,
    },
  },
  cloudops_request: {
    pod_onboarding: {
      day: 8,
    },
    user_onboarding: {
      day: 0,
    },
  },
  azure_onboarding: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 2,
    },
  },
  azure_iam_request: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 2,
    },
  },
  sagemaker_provisioning: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 2,
    },
  },
  sagemaker_onboarding: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 2,
    },
  },
  role_policy_creation: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 0,
    },
  },
  databricks_onboarding: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 0,
    },
  },
  onboarding_users: {
    pod_onboarding: {
      day: 13,
    },
    user_onboarding: {
      day: 0,
    },
  },
  role_policy_creation_prod: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 0,
    },
  },
  cloud_request_execution: {
    pod_onboarding: {
      day: 0,
    },
    user_onboarding: {
      day: 0,
    },
    cloud_request: {
      day: 2,
    },
  },
  gha_team_mapping: {
    pod_onboarding: {
      day: 12,
    },
    user_onboarding: {
      day: 0,
    },
    cloud_request: {
      day: 1,
    },
  },
  wandb_onboarding: {
    pod_onboarding: {
      day: 13,
    },
    user_onboarding: {
      day: 0,
    },
    cloud_request: {
      day: 0,
    },
  }
};

export const requestDetailsLabelMapping = {
  pod_name: "Pod Name",
  email: "Email",
  user_role: "User Role",
  description: "Project Description",
  business_justification: "Business Justification",
  comments: "Comments",
  name: "Name",
  ambassador_email: "Ambassador Email",
};

export const DUPLICATE_USER_ENTRY_ERROR =
  "Duplicate entry not allowed. Combination of user email and role must be unique for each entry";
export const LANDING_PAGE = {
  title:
    "Empowering Data Scientists: Seamless AI/ ML Model Development with TDSP",
  sub_title:
    "With a powerful architecture designed for data scientists, TDSP offers a unified platform with automated pipelines that simplifies the complexities of building, training, and deploying AI/ML models at scale. A platform that provides all the tools and cloud infra to build models.",
  primary_btn_text: "Get Started",
  secondary_btn_text: "Know More",
  feature_section_title: "Powering AI/ML with Toyota Data Science Platform",
  feature_section_desc:
    "Toyota Data Science Platform (TDSP) is built with state-of-the-art architecture to cater to Data Scientists with MLOps pipelines using advanced tech stacks required to develop, train, test, and deploy AI/ML models.",
};

export const SELF_SERVICE_CATALOG_LIST: Array<CatalogSection> = [
  {
    title: "Onboarding",
    items: [
      {
        title: "User Onboarding",
        description:
          "User Onboarding enables new members to seamlessly join an existing POD in TDSP with the right access, tools, and resources.",
        content: [
          {
            title: "What's Included ?",
            contentItems: [
              "Access & Permissions: Auto-configured IAM roles & AWS cloud access.",
              "Tools Access: DE/ML development  tools like SageMaker, W&B, and Databricks.",
            ],
          },
          {
            title: "Pre-requisite",
            contentItems: [
              "Existing team (pod) name.",
              "You should know your requirement/use-case/business justification.",
            ],
          },
        ],
        docsRoute: "/documentation/422609195",
        selectEndpoint: "user-onboarding",
        CardImage: UserIcon,
      },
      {
        title: "Pod Onboarding",
        description:
          "Pod Onboarding streamlines the setup of a new Data Science team in TDSP, ensuring seamless access, configurations, and prerequisite setups.",
        content: [
          {
            title: "What's Included ?",
            contentItems: [
              "Access & Permissions: Auto-configured IAM roles & AWS cloud access.",
              "Pre-configured Tools: DE/ML development  tools like SageMaker, W&B, and Databricks.",
            ],
          },
          {
            title: "Pre-requisite",
            contentItems: [
              "New team (pod) name.",
              "Requirement/use-case/business-justification.",
            ],
          },
        ],
        docsRoute: "/documentation/422609195",
        selectRoute: "/",
        selectEndpoint: "pod-onboarding",
        CardImage: GroupIcon,
      },
    ],
  },
  {
    title: "MLOps Pipeline Templates",
    items: [
      {
        title: "Training Template",
        description:
          "Generates a GitHub template to streamline the setup for training machine learning models. Click on the button to generate the Training Template.",
        docsRoute: "/documentation/519832860",
        selectRoute: "/",
        cardIconPath: "/assets/group-icon.svg",
        selectEndpoint: "mlops-template/training-template",
        content: [
          {
            title: "What's Included ?",
            contentItems: [
              "Standardized Template: Pre-designed template for creating sample repositories tailored to different pipeline requirements.",
              "Documentation to streamline the setup of sample repositories.",
            ],
          },
          {
            title: "Pre-requisite",
            contentItems: [
              "Model Configuration (Train Comp Type, Train Dist Type, Train S3 URI, Validation Comp Type, Validation Dist Type, Validation S3 URI, Test Comp Type, Test Dist Type and Test S3 URI.)",
              "Weights & Biases Configuration (WB Project Name, Model Name and Model Version)",
              "Github PAT (Personal Access Token), in case pushing to github.",
              "Team (Pod) name.",
            ],
          },
        ],
        CardImage: TrainingImage,
      },
      {
        title: "Batch Template",
        description:
          "Provides a GitHub template for deploying and managing machine learning model Routes. Click on the button to generate a Batch Template.",
        docsRoute: "/documentation/519832860",
        selectRoute: "/",
        cardIconPath: "/assets/group-icon.svg",
        selectEndpoint: "mlops-template/batch-template",
        content: [
          {
            title: "What's Included ?",
            contentItems: [
              "Standardized Template: Pre-designed template for creating sample repositories tailored to different pipeline requirements.",
              "Documentation to streamline the setup of sample repositories.",
            ],
          },
          {
            title: "Pre-requisite",
            contentItems: [
              "Transform Job Configurations (Batch Strategy, Input Type, Input Inference Path, Output Inference Path, Instance Count, Instance Type, Max Payload In MB and Max concurrent transforms)",
              "Weights & Biases Configuration (WB Project Name, Model Name and Model Version)",
              "Github PAT (Personal Access Token), in case pushing to github.",
              "Team (Pod) name.",
            ],
          },
        ],
        CardImage: BatchImage,
      },
      {
        title: "Endpoint Template",
        description:
          "Creates a GitHub template designed for efficient batch processing workflows. Click on the button to generate a Route Template.",
        content: [
          {
            title: "What's Included ?",
            contentItems: [
              "Standardized Template: Pre-designed template for creating sample repositories tailored to different pipeline requirements.",
              "Documentation to streamline the setup of sample repositories.",
            ],
          },
          {
            title: "Pre-requisite",
            contentItems: [
              "Endpoint Configuration (Variant Name, Instance Count, Instance Type)",
              "Weights & Biases Configuration (WB Project Name, Model Name and Model Version)",
              "Github PAT (Personal Access Token), in case pushing to github.",
              "Team (Pod) name.",
            ],
          },
        ],
        docsRoute: "/documentation/519832860",
        selectRoute: "/",
        cardIconPath: "/assets/group-icon.svg",
        selectEndpoint: "mlops-template/endpoint-template",
        CardImage: EndpointImage,
      },
    ],
  },
  {
    title: "Cloud Service Provisioning",
    items: [],
  },
];

export const SELF_SERVICE_PAGE_CONSTANTS = {
  title: "Self Service Portal",
  description:
    "Self service offers onboarding feature and MLOps pipline templates.",
  keyFeatures: "Key Features",
};

export const TEAM_DIRECTORY_CONSTANT = {
  title: "Team Directory",
  description:
    "Meet the Team Behind TDSP’s Powerful Architecture for Seamless AI/ML Operations.",
};

export const EMAIL_ERROR =
  "Email Id not exist. Please enter a valid Toyota email id.";
export const POD_ERROR = "Pod Abbreviation already exist.";
export const EMAIL_VALIDATION_FAILED = "Email validation failed!";
export const POD_VALIDATION_FAILED = "Pod validation failed!";

export const USER_ONBOARDING_FLOW = [
  {
    image: "/assets/request-document.svg",
    stageTitle: "Request Initiated",
    SLA: "",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Pod owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Platform’s owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/onboarding.svg",
    stageTitle: "Azure Onboarding",
    SLA: "1 Hour Approx",
  },
  {
    image: "/assets/sagemaker-circle.svg",
    stageTitle: "Sagemaker Provisioning",
    SLA: "1 Hour Approx",
  },
];

export const USER_OFFBOARDING_FLOW = [
  {
    image: "/assets/request-document.svg",
    stageTitle: "Request Initiated",
    SLA: "",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Pod owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Platform’s owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/onboarding.svg",
    stageTitle: "Azure Offboarding",
    SLA: "1 Hour Approx",
  },
];

export const POD_ONBOARDING_FLOW = [
  {
    image: "/assets/request-document.svg",
    stageTitle: "Request Initiated",
    SLA: "",
  },
  {
    image: "/assets/approval.svg",
    stageTitle: "User’s manager approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Platform’s owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/onboarding.svg",
    stageTitle: "Azure and Britive Setup",
    SLA: "7 Days",
  },
  {
    image: "/assets/gha-team-mapping.svg",
    stageTitle: "GHA Team Mapping",
    SLA: "1 Hour Approx",
  },
  {
    image: "/assets/policy.svg",
    stageTitle: "Roles/Policy Provisioning",
    SLA: "7 Hours Approx",
  },
  {
    image: "/assets/provisioning.svg",
    stageTitle: "Databricks and Sagemaker Provisioning",
    SLA: "1 Hour Approx",
  },
  {
    image: "/assets/wandb.svg",
    stageTitle: "Weights and Biases Provisioning",
    SLA: "1 Day Approx",
  },
  {
    image: "/assets/users.svg",
    stageTitle: "Users Onboarding",
    SLA: "1 Hour Approx",
  }
];

export const resetText = "Reset";
export const FOOTER_TEXTS = {
  footerLeft: "Toyota Data Science Platform",
  footerRight: "COPYRIGHT © {copyRightYear} | All Rights Reserved",
};

export const CLOUD_SERVICE_PROVISIONING_FLOW = [
  {
    image: "/assets/request-document.svg",
    stageTitle: "Request Initiated",
    SLA: "",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Pod owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Platform’s owner approval",
    SLA: "2 Day",
  },
  {
    image: "/assets/platform-approval.svg",
    stageTitle: "Service Request Execution",
    SLA: "",
  },
];

export const CLOUD_SERVICE_PAGE_CONSTANTS = {
  formTitle: "Initiate Request",
  title: "Cloud Service Provisioning",
  requestSubmitError:
    "There was an error submitting your request. Please try again.",
  requestFailedMessage: "Submission Failed",
  requestSuccessMessage: "Request Raised Successfully",
  requestSuccessInfo: "Cloud service request has been successfully created.",
  trackCloudRequestsTitle: "Cloud Service Details",
  statusTitles: {
    status: "Status",
    updatedAt: "Updated at",
  },
  markedProvisioning:"Mark Provisioned",
  provisionedSuccessfully:"Provisioned Successfully",
  toLearnMore: "To Learn More",
  readDocs: "Read Docs",
  select: "Select"
};
